import React from 'react';
import Button from './Button';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

/**
 * État vide : un cercle crème avec l'icône en rouge ATABLE, un titre court,
 * une phrase d'explication et au plus deux actions. Jamais de gris froid.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  secondaryAction,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-14 px-6 text-center ${className}`}>
      {icon && (
        <div className="w-16 h-16 mb-5 rounded-full bg-cream-200 dark:bg-gray-800 flex items-center justify-center text-brand-500 [&>svg]:w-7 [&>svg]:h-7">
          {icon}
        </div>
      )}

      <h2 className="section-title">{title}</h2>

      {description && (
        <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400 max-w-md leading-relaxed">{description}</p>
      )}

      {(action || secondaryAction) && (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {action && (
            <Button variant="primary" size="md" onClick={action.onClick}>{action.label}</Button>
          )}
          {secondaryAction && (
            <Button variant="outline" size="md" onClick={secondaryAction.onClick}>{secondaryAction.label}</Button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
